/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How often the leaderboard recurs. ONE_TIME = no recurrence (admin sets explicit start+end). DAILY/WEEKLY/MONTHLY = standard recurrences with server-derived endAt. CUSTOM = day-of-week + time-window pattern (see customRecurrenceRule).
 * @export
 */
export const LeaderboardPeriodType = {
    ONE_TIME: 'ONE_TIME',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    CUSTOM: 'CUSTOM'
} as const;
export type LeaderboardPeriodType = typeof LeaderboardPeriodType[keyof typeof LeaderboardPeriodType];


export function instanceOfLeaderboardPeriodType(value: any): boolean {
    for (const key in LeaderboardPeriodType) {
        if (Object.prototype.hasOwnProperty.call(LeaderboardPeriodType, key)) {
            if (LeaderboardPeriodType[key as keyof typeof LeaderboardPeriodType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeaderboardPeriodTypeFromJSON(json: any): LeaderboardPeriodType {
    return LeaderboardPeriodTypeFromJSONTyped(json, false);
}

export function LeaderboardPeriodTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardPeriodType {
    return json as LeaderboardPeriodType;
}

export function LeaderboardPeriodTypeToJSON(value?: LeaderboardPeriodType | null): any {
    return value as any;
}

export function LeaderboardPeriodTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): LeaderboardPeriodType {
    return value as LeaderboardPeriodType;
}

